import { RULE_STATES, stateMeta } from "@/lib/validationConstants";

/** All / Inference / Validated / Rejected filter chips with counts (Iter 40). */
export default function RuleStateChips({ byState = {}, total = 0, active = "", onChange }) {
  const chips = [{ key: "", label: "All", count: total }].concat(
    RULE_STATES.map((s) => ({ key: s, label: stateMeta(s).label, count: byState[s] || 0, meta: stateMeta(s) })),
  );
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="br-state-chips">
      {chips.map((c) => {
        const isActive = active === c.key;
        return (
          <button
            key={c.key || "all"}
            type="button"
            onClick={() => onChange(isActive ? "" : c.key)}
            data-testid={`br-state-chip-${c.key || "all"}`}
            data-active={isActive}
            className={`ml-mono text-[10px] uppercase tracking-widest px-2 py-1 border transition-colors ${
              isActive
                ? "border-[var(--ml-primary)] bg-[var(--ml-primary)] text-white"
                : "border-[var(--ml-border)] hover:border-[var(--ml-primary)]/60"
            }`}
            style={!isActive && c.meta ? { color: c.meta.fg } : undefined}
          >
            {c.label} <span className="tabular-nums opacity-80">{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
